import { CapTableCellWithReferences } from '../captable-table/CaptableTable.props';

/**
 * Whether a cell renders its own inline control (a select dropdown or a date
 * picker) that the citation badge must not overlap. For these cells the citation
 * viewer reserves horizontal space for the badge instead of overlaying it, so
 * the indicator stays usable and the popover anchors cleanly (SCAL-8987).
 */
export const hasInlineControl = (cell?: Partial<CapTableCellWithReferences>): boolean =>
  Boolean(cell?.dropdown || cell?.gridDateComponent);
